var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMemoryGame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 200,
    viewBox: "0 0 201 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.4 175C58.9775 175 25.4001 141.423 25.4001 100C25.4001 58.5774 58.9775 25 100.4 25C141.823 25 175.4 58.5774 175.4 100C175.4 141.423 141.823 175 100.4 175Z",
    fill: "url(#paint0_linear_26801_488)",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.9327 96H34.748C32.8466 96 31.3054 94.3839 31.3054 92.39V42.61C31.3054 40.6161 32.8466 39 34.748 39H68.9327C70.8342 39 72.3753 40.6161 72.3753 42.61V92.39C72.3753 94.3839 70.8342 96 68.9327 96Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.25 94.5048H83.0659C81.1644 94.5048 79.6233 92.9637 79.6233 91.0622V43.5901C79.6233 41.6887 81.1644 40.1475 83.0659 40.1475H117.251C119.152 40.1475 120.693 41.6887 120.693 43.5901V91.0622C120.693 92.9637 119.151 94.5048 117.25 94.5048Z",
    fill: "url(#paint1_linear_26801_488)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M165.568 96H131.383C129.482 96 127.941 94.3839 127.941 92.39V42.61C127.941 40.6161 129.482 39 131.383 39H165.568C167.469 39 169.011 40.6161 169.011 42.61V92.39C169.011 94.3839 167.469 96 165.568 96Z",
    fill: "#94A3B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M138.317 74.813H158.635C159.533 74.813 160.083 73.8267 159.611 73.0624L149.452 56.6147C149.003 55.8889 147.948 55.8889 147.499 56.6147L137.34 73.0624C136.868 73.8273 137.418 74.813 138.317 74.813Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M68.9327 161H34.748C32.8466 161 31.3054 159.412 31.3054 157.453V108.547C31.3054 106.588 32.8466 105 34.748 105H68.9327C70.8342 105 72.3753 106.588 72.3753 108.547V157.453C72.3753 159.412 70.8342 161 68.9327 161Z",
    fill: "#94A3B8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M116.963 161H82.8369C80.9387 161 79.4001 159.412 79.4001 157.453V108.547C79.4001 106.588 80.9387 105 82.8369 105H116.963C118.862 105 120.4 106.588 120.4 108.547V157.453C120.4 159.412 118.861 161 116.963 161Z",
    fill: "#94A3B8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9987 140.559H110.316C111.215 140.559 111.765 139.572 111.293 138.808L101.134 122.36C100.685 121.634 99.6294 121.634 99.1813 122.36L89.0221 138.808C88.5505 139.573 89.1001 140.559 89.9987 140.559Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165.568 160.25H131.383C129.482 160.25 127.94 158.709 127.94 156.808V109.336C127.94 107.434 129.482 105.893 131.383 105.893H165.568C167.469 105.893 169.01 107.434 169.01 109.336V156.808C169.01 158.709 167.469 160.25 165.568 160.25Z",
    fill: "url(#paint2_linear_26801_488)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.896 61.3897C90.896 60.2806 91.2517 59.1572 91.9638 58.0188C94.5343 53.91 100.539 53.1727 104.345 55.0065C108.693 57.1025 109.847 62.1918 106.367 65.6012C104.677 67.2553 103.23 68.3753 102.427 69.2963C100.811 71.1449 101.949 73.7527 99.2484 73.7527C98.067 73.7527 97.0944 72.9856 97.0944 71.3888C97.0944 65.5736 103.591 64.6625 103.591 61.0919C103.591 57.5552 98.7245 56.9212 97.0244 58.7366C96.4174 59.3844 95.9039 60.3385 95.4833 61.5997C94.4757 64.9494 90.896 63.5046 90.896 61.3897ZM96.78 77.9556C96.78 74.5078 102.051 74.4929 102.051 77.9556C102.051 81.4774 96.78 81.4349 96.78 77.9556Z",
    fill: "url(#paint3_linear_26801_488)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M139.719 125.51C139.719 118.06 152.068 115.437 156.172 121.675C157.513 123.716 157.492 126.182 156.627 127.786C154.992 130.822 151.09 132.557 150.445 134.852C150.068 136.184 150.11 137.873 148.072 137.873C146.891 137.873 145.918 137.106 145.918 135.509C145.918 131.477 148.608 130.281 151.234 127.655C152.902 125.985 152.673 124.051 151.374 122.849C150.679 122.206 149.783 121.885 148.685 121.885C143.424 121.885 145.483 127.699 142.048 127.699C140.672 127.699 139.719 126.535 139.719 125.51ZM145.603 142.076C145.603 139.666 148.535 138.635 150.121 140.22C151.198 141.297 151.079 143.12 150.086 144.002C148.459 145.449 145.603 144.588 145.603 142.076Z",
    fill: "url(#paint4_linear_26801_488)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0822 144.445C58.3631 144.445 63.4549 139.353 63.4549 133.072C63.4549 126.791 58.3631 121.699 52.0822 121.699C45.8012 121.699 40.7095 126.791 40.7095 133.072C40.7095 139.353 45.8012 144.445 52.0822 144.445Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0176 74.144V63.0117C64.0176 62.1918 63.5803 61.4338 62.87 61.0242L53.229 55.458C52.5186 55.0478 51.6442 55.0478 50.9339 55.458L41.2928 61.0242C40.5825 61.4344 40.1453 62.1918 40.1453 63.0117V74.144C40.1453 74.9639 40.5825 75.7219 41.2928 76.1315L50.9339 81.6977C51.6442 82.1079 52.5186 82.1079 53.229 81.6977L62.87 76.1315C63.5803 75.7213 64.0176 74.9639 64.0176 74.144Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M117.25 95.6524H83.0658C80.5348 95.6524 78.4756 93.5931 78.4756 91.0622V43.5902C78.4756 41.0593 80.5348 39 83.0658 39H117.25C119.781 39 121.84 41.0593 121.84 43.5902V91.0622C121.84 93.5931 119.781 95.6524 117.25 95.6524ZM83.0658 41.2951C81.8 41.2951 80.7707 42.3244 80.7707 43.5902V91.0622C80.7707 92.3279 81.8 93.3573 83.0658 93.3573H117.25C118.516 93.3573 119.545 92.3279 119.545 91.0622V43.5902C119.545 42.3244 118.516 41.2951 117.25 41.2951H83.0658Z",
    fill: "url(#paint5_linear_26801_488)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M165.568 161.398H131.383C128.852 161.398 126.793 159.339 126.793 156.808V109.336C126.793 106.805 128.852 104.745 131.383 104.745H165.568C168.099 104.745 170.158 106.805 170.158 109.336V156.808C170.158 159.339 168.099 161.398 165.568 161.398ZM131.383 107.041C130.117 107.041 129.088 108.07 129.088 109.336V156.808C129.088 158.073 130.117 159.103 131.383 159.103H165.568C166.834 159.103 167.863 158.073 167.863 156.808V109.336C167.863 108.07 166.834 107.041 165.568 107.041H131.383Z",
    fill: "url(#paint6_linear_26801_488)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26801_488",
    x1: 25.4001,
    y1: 36.7188,
    x2: 168.369,
    y2: 166.404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85DCEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26801_488",
    x1: 100.158,
    y1: 40.1475,
    x2: 100.158,
    y2: 94.5048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26801_488",
    x1: 148.475,
    y1: 105.893,
    x2: 148.475,
    y2: 160.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26801_488",
    x1: 92.8117,
    y1: 54.0591,
    x2: 116.861,
    y2: 63.9591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26801_488",
    x1: 141.635,
    y1: 118.18,
    x2: 165.685,
    y2: 128.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3D527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26801_488",
    x1: 100.158,
    y1: 39,
    x2: 100.158,
    y2: 95.6524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_26801_488",
    x1: 148.475,
    y1: 104.745,
    x2: 148.475,
    y2: 161.398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBCAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6183E4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemoryGame);
export default __webpack_public_path__ + "static/media/Memory-Game.51d4630e8a2e28f61ea0fd9335fe41a3.svg";
export { ForwardRef as ReactComponent };